module.exports = __webpack_public_path__ + "media/assets/images/logos/AWS-select-consulting-partner-f2fe7d540d5b068ecfab9837b10fd376.jpg";